import { FEATURE_TOUR_SETTINGS } from 'qap/constants'

const getDefaultFeatureTours = () =>
// @ts-expect-error - TS2558 - Expected 1 type arguments, but got 2.
  Object.fromEntries<string, null>(Object.keys(FEATURE_TOUR_SETTINGS)
    .filter((key) => FEATURE_TOUR_SETTINGS[key])
    .map((key) => [key, null]))

const DEFAULT_FEATURE_TOURS = getDefaultFeatureTours()

export { DEFAULT_FEATURE_TOURS }
